import { css } from '@emotion/react';

const tableStyles = css`
    table {
        width: 90%;

        th {
            border-bottom: 1px solid #ccc;
        }
    }
`;

export const distributionsTableThemeStyles = css`
    table {
        width: var(--tableComponent-tableWidth);

        th {
            border-style: var(--tableComponent-thBorderStyle);
            border-color: var(--tableComponent-thBorderColor);
            border-width: var(--tableComponent-thBorderWidth);
            font-family: var(--tableComponent-thFontFamily);
            color: var(--tableComponent-thTextColor);
            font-weight: var(--tableComponent-thFontWeight);
            font-size: var(--tableComponent-thFontSize);
            line-height: var(--tableComponent-thLineHeight);
            padding: var(--tableComponent-thPadding);
        }

        td {
            border-style: var(--tableComponent-tdBorderStyle);
            border-color: var(--tableComponent-tdBorderColor);
            border-width: var(--tableComponent-tdBorderWidth);
            font-family: var(--tableComponent-tdFontFamily);
            color: var(--tableComponent-tdTextColor);
            font-weight: var(--tableComponent-tdFontWeight);
            font-size: var(--tableComponent-tdFontSize);
            line-height: var(--tableComponent-tdLineHeight);
            padding: var(--tableComponent-tdPadding);
        }

        tbody {
            tr:nth-child(odd) {
                background-color: var(--tableComponent-alternatedRowsBGColor);
            }
        }

        tr:last-child {
            td {
                border: none;
            }
        }
    }

    button {
        background-color: var(--buttonComponent-primaryBackgroundColor);
        border-color: var(--buttonComponent-primaryBorderColor);
        border-style: var(--buttonComponent-borderStyle);
        border-width: var(--buttonComponent-borderWidth);
        font-size: var(--buttonComponent-fontSize);
        font-weight: var(--buttonComponent-fontWeight);
        font-family: var(--buttonComponent-fontFamily);
        line-height: var(--buttonComponent-lineHeight);
        padding: var(--buttonComponent-padding);
        border-radius: var(--buttonComponent-borderRadius);
        color: var(--buttonComponent-textColor);
    }

    .row--group:nth-of-type(odd) {
        background-color: var(--tableComponent-alternatedRowsBGColor);
    }
`;

export default tableStyles;
